import React from 'react';

import { Container, Button } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { SOLUTION_TYPE } from '../../../../shared/constants/user-info/solutionType';
import { PromoCodesList } from '../../../containers/NgzPromoCodesList/NgzPromoCodesList';
import { ErrorState } from '../../../../shared/components/ErrorState/ErrorState';
import { goToHomePage } from '../../../../shared/utils/angularUtils';

const NgzScanIqPromoCodesPage = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();
  const { scanIqBillingType } = loggedInUserDataStore;

  if (scanIqBillingType.SELF_BILLING) {
    return (
      <ErrorState
        title="Promo Codes are not available for self-billing"
        description="Promo Codes can only be managed for entities on automated billing."
      >
        <Button variant="contained" onClick={goToHomePage}>
          Return to the Main Page
        </Button>
      </ErrorState>
    );
  }

  return (
    <Container>
      <PromoCodesList targetId={entityId} solutionType={SOLUTION_TYPE.SCAN_IQ} />
    </Container>
  );
});

angularizeWithProviders(NgzScanIqPromoCodesPage, 'ngzScanIqPromoCodesPage', {});

export { NgzScanIqPromoCodesPage };
